// Notify.js
import Vue from "vue";

export const notify = (options) => {
  Vue.prototype.$notify(options);
};